"use strict";
import { TransactionStepType } from "features/transactions/steps/types";
import { parseERC20ApproveCalldata } from "utils/approvals";
export function createRevocationTransactionStep(txRequest, token) {
  if (!txRequest?.data) {
    return void 0;
  }
  const type = TransactionStepType.TokenRevocationTransaction;
  const { spender, amount } = parseERC20ApproveCalldata(txRequest.data.toString());
  if (amount !== BigInt(0)) {
    return void 0;
  }
  return { type, txRequest, token, spender, amount: "0" };
}
